import * as types from './types'
import { v4 as uuidv4 } from 'uuid'

export const SYSTEM_SETUP_JOB_CATEGORY = 'Job Category'
export const SYSTEM_SETUP_JOB_STAGE = 'Job Stage'
export const SYSTEM_SETUP_SALARY_TYPE = 'Salary Type'
export const SYSTEM_SETUP_CANDIDATE_CATEGORY = 'Candidate Category'
export const SYSTEM_SETUP_SCREENING_TYPE = 'Screening Type'
export const SYSTEM_SETUP_SCREEN_INDICATOR = 'Screen Indicator'
export const SYSTEM_SETUP_OFFER_LETTER_SETTINGS = 'Offer Letter Settings'

export const JOB_DETAIL_DETAILS = 'JOB_DETAIL_DETAILS'
export const JOB_DETAIL_QUESTIONS = 'JOB_DETAIL_QUESTIONS'
export const JOB_DETAIL_DESCRIPTIONS = 'JOB_DETAIL_DESCRIPTIONS'
export const JOB_DETAIL_APPLICATIONS = 'JOB_DETAIL_APPLICATIONS'
export const AI_INTERVIEW_RANKINGS = 'AI_INTERVIEW_RANKINGS'
export const APPEALS = 'APPEALS'

export const JOB_DETAIL_NOTES = 'JOB_DETAIL_NOTES'
export const JOB_DETAIL_TODO = 'JOB_DETAIL_TODO'

export const APPLICATION_DETAIL_DETAILS = 'APPLICATION_DETAIL_DETAILS'
export const APPLICATION_DETAIL_INTERVIEW = 'APPLICATION_DETAIL_INTERVIEW'
export const APPLICATION_DETAIL_RATING = 'APPLICATION_DETAIL_RATING'
export const APPLICATION_DETAIL_NOTES = 'APPLICATION_DETAIL_NOTES'
export const APPLICATION_DETAIL_TODO = 'APPLICATION_DETAIL_TODO'

const initialState = {
  createJobSlide: 0,
  systemSetupSidebarRoutes: [
    SYSTEM_SETUP_JOB_CATEGORY,
    SYSTEM_SETUP_JOB_STAGE,
    SYSTEM_SETUP_SALARY_TYPE,
    SYSTEM_SETUP_CANDIDATE_CATEGORY,
    SYSTEM_SETUP_SCREENING_TYPE,
    SYSTEM_SETUP_SCREEN_INDICATOR,
    SYSTEM_SETUP_OFFER_LETTER_SETTINGS,
  ],
  activeSystemSetupSidebarRoute: SYSTEM_SETUP_JOB_CATEGORY,
  currentSystemSetupData: {},
  currentSystemSetupRows: [],
  systemSetupModalOpened: false,
  editingSystemSetup: false,
  showAreYouSureModal: { show: false, customFn: () => {} },
  showAlertModal: { show: false, text: '' },
  submittedForm: false,
  offerLetterText: ``,
  jobScreenings: [],
  jobProps: [],
  skills: [],
  jobs: [],
  currentJobDetailRoute: JOB_DETAIL_DETAILS,
  jobApplications: [],
  currentApplicationDetailRoute: APPLICATION_DETAIL_DETAILS,
  jobApplication: {},
  archivedJobs: [],
  onboardingJobs: [],
  interviews: [],
  applicationNotes: [],
  applicationTodos: [],
  allApplications: [],
  filterStartDate: null,
  filterEndDate: null,
  filterJobStage: null,
  filterJob: null,
  careerJobs: [],
  jobTrackingId: null,
  trackingResult: null,
  offerLetterData: null,
  errorMessage: '',
  creatingApplication: false,
  reviewingApplications: false,
  aiInterviewIntroduction: '',
  aiInterviewConclusion: '',
  stopInterviewOnTabChange: false,
  aiInterviewRankings: [],
  appeals: [],
  aiQuestions: [
    {
      id: uuidv4(),
      question: '',
      feedback: '',
      time_limit: 60,
      allow_input: 0,
    },
  ],
}

const recruitmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_CREATE_JOB_SLIDE:
      return { ...state, createJobSlide: action.payload }

    case types.SET_ACTIVE_SYSTEM_SETUP_SIDEBAR_ROUTE:
      return { ...state, activeSystemSetupSidebarRoute: action.payload }

    case types.SET_CURRENT_SYSTEM_SETUP_DATA:
      return { ...state, currentSystemSetupData: action.payload }

    case types.RESET_SYSTEM_SETUP_DATA:
      return {
        ...state,
        currentSystemSetupData: {},
        editingSystemSetup: false,
        submittedForm: false,
      }

    case types.RESET_AI_INTERVIEW_SETUP:
      return {
        ...state,
        aiInterviewConclusion: '',
        aiInterviewIntroduction: '',
        stopInterviewOnTabChange: false,
        aiQuestions: [
          {
            id: uuidv4(),
            question: '',
            feedback: '',
            time_limit: 60,
            allow_input: 0,
          },
        ],
      }

    case types.SET_CURRENT_SYSTEM_SETUP_ROWS:
      return { ...state, currentSystemSetupRows: action.payload }

    case types.SET_SYSTEM_SETUP_CREATE_EDIT_MODAL:
      return { ...state, systemSetupModalOpened: action.payload }

    case types.SET_SYSTEM_SETUP_EDITING:
      return { ...state, editingSystemSetup: action.payload }

    case types.SET_SHOW_ARE_YOU_SURE_MODAL:
      return { ...state, showAreYouSureModal: action.payload }

    case types.SET_FORM_SUBMITTED:
      return { ...state, submittedForm: action.payload }

    case types.SET_OFFER_LETTER:
      return { ...state, offerLetterText: action.payload }

    case types.SET_JOB_SCREENINGS:
      return { ...state, jobScreenings: action.payload }

    case types.SET_JOB_PROPS:
      return { ...state, jobProps: action.payload }

    case types.SET_SKILLS:
      return { ...state, skills: action.payload }

    case types.SET_JOBS:
      return { ...state, jobs: action.payload }

    case types.SET_SHOW_ALERT_MODAL:
      return { ...state, showAlertModal: action.payload }

    case types.RESET_JOB_PROPS:
      return { ...state, jobProps: [] }

    case types.SET_JOB_DETAIL_ROUTE:
      return { ...state, currentJobDetailRoute: action.payload }

    case types.SET_JOB_APPLICATIONS:
      return { ...state, jobApplications: action.payload }

    case types.SET_APPLICATION_DETAIL_ROUTE:
      return { ...state, currentApplicationDetailRoute: action.payload }

    case types.SET_JOB_APPLICATION:
      return { ...state, jobApplication: action.payload }

    case types.SET_ARCHIVED_JOBS:
      return { ...state, archivedJobs: action.payload }

    case types.SET_ONBOARDINGG_JOBS:
      return { ...state, onboardingJobs: action.payload }

    case types.SET_INTERVIEWS:
      return { ...state, interviews: action.payload }

    case types.SET_APPLICATION_NOTES:
      return { ...state, applicationNotes: action.payload }

    case types.SET_APPLICATION_TODO:
      return { ...state, applicationTodos: action.payload }

    case types.SET_ALL_APPLICATIONS:
      return { ...state, allApplications: action.payload }

    case types.SET_FILTER_START_DATE:
      return { ...state, filterStartDate: action.payload }

    case types.SET_FILTER_END_DATE:
      return { ...state, filterEndDate: action.payload }

    case types.SET_FILTER_JOB_STAGE:
      return { ...state, filterJobStage: action.payload }

    case types.SET_FILTER_JOB:
      return { ...state, filterJob: action.payload }

    case types.RESET_APPLICATION_FILTERS:
      return {
        ...state,
        filterStartDate: null,
        filterEndDate: null,
        filterJobStage: null,
        filterJob: null,
      }

    case types.SET_CAREER_JOBS:
      return {
        ...state,
        careerJobs: action.payload,
      }

    case types.SET_JOB_TRACKING_ID:
      return {
        ...state,
        jobTrackingId: action.payload,
      }

    case types.SET_TRACKING_RESULT:
      return {
        ...state,
        trackingResult: action.payload,
      }

    case types.SET_OFFER_LETTER_DATA:
      return {
        ...state,
        offerLetterData: action.payload,
      }

    case types.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload,
      }

    case types.SET_CREATING_APPLICATION:
      return { ...state, creatingApplication: action.payload }

    case types.SET_REVIEWING_APPLICATIONS:
      return { ...state, reviewingApplications: action.payload }

    case types.SET_AI_INTERVIEW_QUESTIONS:
      return { ...state, aiQuestions: action.payload }

    case types.SET_AI_INTERVIEW_INTRODUCTION:
      return { ...state, aiInterviewIntroduction: action.payload }

    case types.SET_AI_INTERVIEW_CONCLUSION:
      return { ...state, aiInterviewConclusion: action.payload }

    case types.SET_STOP_INTERVIEW_ON_TAB_CHANGE:
      return { ...state, stopInterviewOnTabChange: action.payload }

    case types.SET_AI_INTERVIEW_RANKINGS:
      return { ...state, aiInterviewRankings: action.payload }

    case types.SET_APPEALS:
      return { ...state, appeals: action.payload }

    default:
      return state
  }
}

export default recruitmentReducer
